import React from 'react'

export const RenderTextArea = ({ input, rows, placeholder, meta: { valid, touched, error, warning } }) =>
<div>
    <textarea {...input} rows={rows} placeholder={placeholder}/>
    { (error   && <span className='validation-states textarea error'>  {error}  </span>) 
      || (warning && <span className='validation-states textarea warning'>{warning}</span>)
      || (valid && <span className={`validation-states textarea valid`}></span>)
    }
</div>